import React, { ReactNode } from "react";
import {
  ButtonIcon,
  ButtonLabel,
  ButtonSpinner,
  StyledButton,
  V3ButtonSize,
  V3ButtonVariant,
} from "./Button.styled";

export type { V3ButtonSize, V3ButtonVariant };

export interface V3ButtonProps {
  children: ReactNode;
  testID: string;
  variant?: V3ButtonVariant;
  size?: V3ButtonSize;
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  className?: string;
  /** For when the visible label alone does not say what the button acts on. */
  ariaLabel?: string;
}

export const V3Button = ({
  children,
  testID,
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled = false,
  iconLeft,
  iconRight,
  type = "button",
  onClick,
  className,
  ariaLabel,
}: V3ButtonProps): JSX.Element => (
  <StyledButton
    type={type}
    $variant={variant}
    $size={size}
    $fullWidth={fullWidth}
    disabled={disabled || loading}
    aria-busy={loading}
    onClick={onClick}
    className={className}
    aria-label={ariaLabel}
    data-testid={testID}
  >
    {loading && <ButtonSpinner data-testid={`${testID}-spinner`} />}
    {!loading && iconLeft && <ButtonIcon>{iconLeft}</ButtonIcon>}
    <ButtonLabel>{children}</ButtonLabel>
    {iconRight && <ButtonIcon>{iconRight}</ButtonIcon>}
  </StyledButton>
);
